// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IMaxRolloverAmountPropertyDto } from './IMaxRolloverAmountPropertyDto';
import {
    IMaxRolloverAmountPropertyDtoFromJSON,
    IMaxRolloverAmountPropertyDtoFromJSONTyped,
    IMaxRolloverAmountPropertyDtoToJSON,
    IMaxRolloverAmountPropertyDtoToJSONTyped,
} from './IMaxRolloverAmountPropertyDto';
import type { IRunOutPropertyDto } from './IRunOutPropertyDto';
import {
    IRunOutPropertyDtoFromJSON,
    IRunOutPropertyDtoFromJSONTyped,
    IRunOutPropertyDtoToJSON,
    IRunOutPropertyDtoToJSONTyped,
} from './IRunOutPropertyDto';
import type { IIsRolloverPropertyDto } from './IIsRolloverPropertyDto';
import {
    IIsRolloverPropertyDtoFromJSON,
    IIsRolloverPropertyDtoFromJSONTyped,
    IIsRolloverPropertyDtoToJSON,
    IIsRolloverPropertyDtoToJSONTyped,
} from './IIsRolloverPropertyDto';
import type { IRolloverClaimsPropertyDto } from './IRolloverClaimsPropertyDto';
import {
    IRolloverClaimsPropertyDtoFromJSON,
    IRolloverClaimsPropertyDtoFromJSONTyped,
    IRolloverClaimsPropertyDtoToJSON,
    IRolloverClaimsPropertyDtoToJSONTyped,
} from './IRolloverClaimsPropertyDto';
import type { IGracePeriodPropertyDto } from './IGracePeriodPropertyDto';
import {
    IGracePeriodPropertyDtoFromJSON,
    IGracePeriodPropertyDtoFromJSONTyped,
    IGracePeriodPropertyDtoToJSON,
    IGracePeriodPropertyDtoToJSONTyped,
} from './IGracePeriodPropertyDto';

/**
 * 
 * @export
 * @interface IExpressSetupPlanExtendedDto
 */
export interface IExpressSetupPlanExtendedDto {
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupPlanExtendedDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupPlanExtendedDto
     */
    parent_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupPlanExtendedDto
     */
    account_type?: IExpressSetupPlanExtendedDtoAccountTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IExpressSetupPlanExtendedDto
     */
    allow_investments?: boolean;
    /**
     * 
     * @type {IGracePeriodPropertyDto}
     * @memberof IExpressSetupPlanExtendedDto
     */
    grace_period_type?: IGracePeriodPropertyDto;
    /**
     * 
     * @type {IRunOutPropertyDto}
     * @memberof IExpressSetupPlanExtendedDto
     */
    run_out_type?: IRunOutPropertyDto;
    /**
     * 
     * @type {IIsRolloverPropertyDto}
     * @memberof IExpressSetupPlanExtendedDto
     */
    is_rollover?: IIsRolloverPropertyDto;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupPlanExtendedDto
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IExpressSetupPlanExtendedDto
     */
    is_custom_prefund_calc?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IExpressSetupPlanExtendedDto
     */
    is_replenished?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IExpressSetupPlanExtendedDto
     */
    is_plan_level_funding?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IExpressSetupPlanExtendedDto
     */
    is_carded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupPlanExtendedDto
     */
    plan_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupPlanExtendedDto
     */
    funding_method_type?: IExpressSetupPlanExtendedDtoFundingMethodTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupPlanExtendedDto
     */
    prefund_replenishment_percent?: number;
    /**
     * 
     * @type {IMaxRolloverAmountPropertyDto}
     * @memberof IExpressSetupPlanExtendedDto
     */
    max_rollover_amount?: IMaxRolloverAmountPropertyDto;
    /**
     * 
     * @type {IRolloverClaimsPropertyDto}
     * @memberof IExpressSetupPlanExtendedDto
     */
    rollover_claims?: IRolloverClaimsPropertyDto;
}

/**
* @export
* @enum {string}
*/
export enum IExpressSetupPlanExtendedDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
* @export
* @enum {string}
*/
export enum IExpressSetupPlanExtendedDtoFundingMethodTypeEnum {
    STANDARD_NOTIONAL = 'STANDARD_NOTIONAL',
    PREFUND_SPENDDOWN = 'PREFUND_SPENDDOWN',
    PREFUND_AND_CONTRIBUTION = 'PREFUND_AND_CONTRIBUTION',
    CONTRIBUTION_ONLY = 'CONTRIBUTION_ONLY'
}


/**
 * Check if a given object implements the IExpressSetupPlanExtendedDto interface.
 */
export function instanceOfIExpressSetupPlanExtendedDto(value: object): value is IExpressSetupPlanExtendedDto {
    return true;
}

export function IExpressSetupPlanExtendedDtoFromJSON(json: any): IExpressSetupPlanExtendedDto {
    return IExpressSetupPlanExtendedDtoFromJSONTyped(json, false);
}

export function IExpressSetupPlanExtendedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpressSetupPlanExtendedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'allow_investments': json['allow_investments'] == null ? undefined : json['allow_investments'],
        'grace_period_type': json['grace_period_type'] == null ? undefined : IGracePeriodPropertyDtoFromJSON(json['grace_period_type']),
        'run_out_type': json['run_out_type'] == null ? undefined : IRunOutPropertyDtoFromJSON(json['run_out_type']),
        'is_rollover': json['is_rollover'] == null ? undefined : IIsRolloverPropertyDtoFromJSON(json['is_rollover']),
        'summary': json['summary'] == null ? undefined : json['summary'],
        'is_custom_prefund_calc': json['is_custom_prefund_calc'] == null ? undefined : json['is_custom_prefund_calc'],
        'is_replenished': json['is_replenished'] == null ? undefined : json['is_replenished'],
        'is_plan_level_funding': json['is_plan_level_funding'] == null ? undefined : json['is_plan_level_funding'],
        'is_carded': json['is_carded'] == null ? undefined : json['is_carded'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'funding_method_type': json['funding_method_type'] == null ? undefined : json['funding_method_type'],
        'prefund_replenishment_percent': json['prefund_replenishment_percent'] == null ? undefined : json['prefund_replenishment_percent'],
        'max_rollover_amount': json['max_rollover_amount'] == null ? undefined : IMaxRolloverAmountPropertyDtoFromJSON(json['max_rollover_amount']),
        'rollover_claims': json['rollover_claims'] == null ? undefined : IRolloverClaimsPropertyDtoFromJSON(json['rollover_claims']),
    };
}

export function IExpressSetupPlanExtendedDtoToJSON(json: any): IExpressSetupPlanExtendedDto {
    return IExpressSetupPlanExtendedDtoToJSONTyped(json, false);
}

export function IExpressSetupPlanExtendedDtoToJSONTyped(value?: IExpressSetupPlanExtendedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'parent_id': value['parent_id'],
        'account_type': value['account_type'],
        'allow_investments': value['allow_investments'],
        'grace_period_type': IGracePeriodPropertyDtoToJSON(value['grace_period_type']),
        'run_out_type': IRunOutPropertyDtoToJSON(value['run_out_type']),
        'is_rollover': IIsRolloverPropertyDtoToJSON(value['is_rollover']),
        'summary': value['summary'],
        'is_custom_prefund_calc': value['is_custom_prefund_calc'],
        'is_replenished': value['is_replenished'],
        'is_plan_level_funding': value['is_plan_level_funding'],
        'is_carded': value['is_carded'],
        'plan_code': value['plan_code'],
        'funding_method_type': value['funding_method_type'],
        'prefund_replenishment_percent': value['prefund_replenishment_percent'],
        'max_rollover_amount': IMaxRolloverAmountPropertyDtoToJSON(value['max_rollover_amount']),
        'rollover_claims': IRolloverClaimsPropertyDtoToJSON(value['rollover_claims']),
    };
}

